<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-27 13:41:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:01:05
 * @name: 选择穿梭框已选
 * @Description: 选择穿梭框已选
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\jurisdiction-get.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="jurisdictionGet">
    <div class="list">
      <div class="item" v-for="item of jurisdiction.treeDataGet" :key="item.id">
        <i class="el-icon-error" @click="del(item)"></i>
        <div class="right">
          <font>{{ jurisdiction.getFullName(item) }}</font>
          <el-select size="mini" v-model="item.select" placeholder="请选择">
            <el-option
              v-for="itemY in item.levels"
              :key="itemY.id"
              :label="itemY | labelFilter"
              :value="itemY.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { debounceation } from '@/utils/decorator';
export default {
  name: "jurisdictionGet",
  props: {
    id: {
      type: Number,
    },
    jurisdiction: {
      type: Object,
    },
  },
  filters: {
    labelFilter(e) {
      return `级别${e.level}-￥${e.price}`;
    },
  },
  created() {
    this.jurisdiction.getDefault({ agency_id: this.id });
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 删除节点
     */
    @debounceation(300)
    del(item) {
      this.jurisdiction.removeNode(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.jurisdictionGet {
  width: 100%;
  height: 100%;
  .list {
    padding: 10px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    @extend .extend-flex-column-normal;
    .item {
      padding: 5px 0;
      @extend .extend-flex-normal;
      i {
        font-size: $Vars-font-miniTitle-size;
        line-height: $Vars-font-miniTitle-size;
        margin-right: 5px;
        @extend .extend-clickElement;
      }
      .right {
        flex: 1;
        @extend .extend-flex-column-normal;
        font {
          font-size: $Vars-font-miniContent-size;
          line-height: $Vars-font-miniTitle-size;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>